import React from "react";
import { PopupCampaignStatsViewModel } from "../../api/generated/models/PopupCampaignStatsViewModel";
import { formatPercent } from "../../helpers/popupCampaignForm";

const n = (v: number | null | undefined) => (v ?? 0).toLocaleString();

const STATS: { label: string; value: (s: PopupCampaignStatsViewModel) => string; color: string }[] = [
  { label: "Impressions", value: (s) => n(s.impressions), color: "text-gray-800" },
  { label: "Dismissals", value: (s) => n(s.dismissals), color: "text-orange-500" },
  { label: "CTA clicks", value: (s) => n(s.ctaClicks), color: "text-indigo-500" },
  { label: "CTR", value: (s) => formatPercent(s.ctr), color: "text-indigo-500" },
  { label: "Dismiss rate", value: (s) => formatPercent(s.dismissRate), color: "text-orange-500" },
];

export const PopupCampaignStats: React.FC<{ stats?: PopupCampaignStatsViewModel | null; compact?: boolean }> = ({
  stats,
  compact,
}) => {
  const s = stats ?? {};
  return (
    <div className={`grid grid-cols-3 sm:grid-cols-5 gap-3 ${compact ? "" : "bg-white rounded-lg shadow p-4"}`}>
      {STATS.map((stat) => (
        <div key={stat.label}>
          <div className="text-[10px] font-medium text-gray-400 uppercase tracking-wide mb-0.5">{stat.label}</div>
          <div className={`${compact ? "text-sm" : "text-lg"} font-bold ${stat.color}`}>{stat.value(s)}</div>
        </div>
      ))}
    </div>
  );
};
